<p-toast position="bottom-right"></p-toast>
<p-confirmDialog appendTo="body"></p-confirmDialog>
<app-exchange-sidebar>
  <app-crud-table body [crudService]="crudService"
                   [transPartKey]="'exchange-detail'" [fieldId]="'code'" [fieldName]="'code'"
                   [tableConfig]="tableConfig" [newRecord]="newRecord"
                   [(formRecord)]="formRecord" [formConfig]="formConfig"
                   (dialogFormVisibleChange)="$event?onFormShow():{}"
                   [formLoading]="formLoading"
                   [settingsFormLoadingProgressValue]="settingsFormLoadingProgressValue"
                   [writeRoles]="CCRoles.ROLES_EXCHANGE_WRITE"
                   [prepareForCreate]="prepareRecordForCreate"
                   [prepareForEdit]="prepareRecordForEdit"
                   [prepareForClone]="prepareRecordForEdit" [totalRecords]="totalRecords"
                  [defaultSortField]="'state'"
  ></app-crud-table>
</app-exchange-sidebar>
